// @flow
import { useContext } from 'react';

import SnackbarContext from '../config/context';

const useSnackbarContext = () => useContext(SnackbarContext);

export default useSnackbarContext;
